module.exports = "/_next/static/files/b9164b25f381c5227a00a799d287311c.svg";